import React from "react";
import { Flex, Text, Code, Box, Container, Separator, Heading, Badge } from "@radix-ui/themes";

const Terms: React.FC = () => {
  return (
    <Box>
	<Container size="2">
        <Flex direction="column" gap="4" px="4" py="9">

            <Heading size="8">Terms of Service</Heading>
            <Heading size="4" weight="regular">Live Football On TV Android App</Heading>
            <Flex direction="row">
              <Text size="2">Last Updated: </Text> 	<Badge color="green">5 August 2025</Badge>
            </Flex>

            <Separator my="3" size="4" />

            <Heading size="6">Subscription</Heading>
            <Heading size="3">Free Trial</Heading>
            <Text size="3">You may be offered a free trial as part of your subscription. The period of the free trial will be communicated to you via the Google payment service. At the end of the free trial, you will be automatically enrolled into a paid subscription which will recur according to its schedule until paused or canceled. Note that you are only eligible for a single free trial through the service – on canceling or ending a free trial you will forfeit the unused portion of the free trial period for any future subscriptions.</Text>
            
            <Heading size="3">Payment</Heading>
            <Text size="3">Your subscription will automatically renew at the frequency set forth at the point of purchase unless paused or canceled. Payment will be charged to the funding instrument which you select on your Google account at the point of purchase. You can change the chargeable funding instrument ahead of subscription renewal by managing your subscription in the Google Play Store (see below).  </Text>
            <Text size="3">Note that your subscription will renew indefinitely unless canceled or paused through the Google Play Store. Deleting your Live Football On TV account will not cancel your subscription.</Text>    

            <Heading size="3">Managing Your Subscription</Heading>
            <Text size="3">You can manage your subscription through the Settings screen in the app. Alternatively, open the Google Play Store app, click the Menu icon, click Subscriptions and then select the Live Football On TV app. </Text>
            <Text size="3">On the Play Store's Manage Subscription page you can view details of the subscription plan you are on, update your primary and backup payment methods, and cancel your subscription. Additionally, if you have a non-yearly subscription you will be able to pause it and resume at a later date. </Text>
            <Text size="3">You are responsible for payment for the full term of the subscription period. After canceling your subscription, you will continue to receive the subscription content until your subscription's renewal date. The cancellation will go into effect as soon as the renewal date passes. Note that we do not offer (partial) refunds. </Text>

            <Heading size="6">Termination</Heading>
            <Text size="3">You may terminate your Live Football On TV account at any time by permanently deleting your account through the Settings screen.</Text>

            <Text size="3"> Live Football On TV may immediately terminate or suspend access to the Android app at any time for any reason and without warning. This may result in the forfeiture and destruction of your data. The cause for such termination may include (but is not limited to): System Abuse; Individual user violation of the Terms of Service; Unexpected technical or security issues; Compliance with regulation. </Text>

            <Text size="3">Please view the Privacy Policy for details on how your personal data is handled on account termination.</Text>

            <Heading size="6">Licenses</Heading>

            <Text size="3"> Patrick Millais and live-footballontv.com are the owners or the licensee of all intellectual property rights of the data and content in this application. </Text>

            <Text size="3">Those works are protected by copyright and database laws and treaties around the world. All such rights are reserved.</Text>

            <Text size="3">You must not use any part of the content and materials from the app for commercial purposes without obtaining a license to do so from us or our licensors.</Text>

            <Text size="3">If you copy or download any part of the data or content in breach of these terms of use your right to use that data will cease immediately and you must, at our option, return or destroy any copies of the data and any materials you have made using it.</Text>

            <Separator my="3" size="4" />
            <Text size="3"> Please contact us if you have any queries.</Text>

        </Flex>
	</Container>
</Box>

  );
};

export default Terms;
